import { commonCbEnv } from "./env.cb.common";

const env: Partial<typeof commonCbEnv> = {
  production: true,
  page: 'bursa-nivel-3',
  meta: {
    siteTitle: 'Caruta cu bani - curs de investitii eficiente pe bursa pentru dividende',
    ogSiteName: 'Caruta Cu Bani',
    siteDescription: '',
    ogImageAlt: '',
    ogUrl: 'https://carutacubani.ro/cursuri/curs-investitii-eficiente-pe-bursa-pentru-dividende/',
    ogImage: 'https://carutacubani.ro/cursuri/curs-investitii-eficiente-pe-bursa-pentru-dividende/assets/images/bursa-nivel-3/cover-fb.png'
  }
};

export const environment = { ...commonCbEnv, ...env };
